"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyModel = void 0;
const V5BaseModel_1 = require("./base/V5BaseModel");
class PolicyModel extends V5BaseModel_1.V5BaseModel {
    constructor(options) {
        super('policy', options);
    }
    get org() {
        return this.options.banks.orgBank.org(this.org_id);
    }
    getOrg() {
        return this.options.banks.orgBank.resolve(this.org_id);
    }
    get id() {
        return this.options.model.id;
    }
    get org_id() {
        return this.options.model.org_id;
    }
    async getParents() {
        return [await this.getOrg()];
    }
}
exports.PolicyModel = PolicyModel;
